import { render, staticRenderFns } from "./ProductGroups.vue?vue&type=template&id=21fb6b84&scoped=true"
import script from "./ProductGroups.vue?vue&type=script&lang=js"
export * from "./ProductGroups.vue?vue&type=script&lang=js"
import style0 from "./ProductGroups.vue?vue&type=style&index=0&id=21fb6b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb6b84",
  null
  
)

export default component.exports